// extracted by mini-css-extract-plugin
export var section = "index-module--section--Demga";
export var section__heroText = "index-module--section__heroText--tEHS8";
export var section__hero = "index-module--section__hero--gMRB8";
export var section__img = "index-module--section__img--843QV";
export var section__title = "index-module--section__title--i1tM0";
export var section__text = "index-module--section__text--uiJSn";
export var subsection = "index-module--subsection--c61k+";
export var subsection__title = "index-module--subsection__title--40Pu2";
export var subsection__text = "index-module--subsection__text--bt-c1";